import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { whatsappMessageService } from "../../services/admin/whatsappMessageService";
import { MetaPagination, ParamType } from "types/Others";
import { RootState } from "redux/store"; 

export const getWhatsappMessageListFromStore = createAsyncThunk(
  "whatsapp/getWhatsappMessageListFromStore",
  async (param: ParamType) => {
    return await whatsappMessageService.getWhatsappMessageList(param);
  }
);

export const sendWelcomeMessageFromStore = createAsyncThunk(
    "whatsapp/sendWelcomeMessageFromStore",
    async (payload: { mobile: string; fullName: string } | { mobile: string; fullName: string }[]) => {
      return await whatsappMessageService.sendWelcomeMessage(payload);
    }
  );
  

type WhatsappMessageState = {
  list: any[];
  isLoading: boolean;
  isLoaded: boolean;
  meta: MetaPagination;
  total: number;
};

const initialState: WhatsappMessageState = {
  list: [],
  isLoading: true,
  isLoaded: false,
  meta: {},
  total: 0,
};

export const whatsappMessageSlice = createSlice({
  name: "whatsappMessage",
  initialState,
  reducers: {
    resetWhatsappMessageList: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWhatsappMessageListFromStore.pending, (state) => {
        state.isLoading = true;
        state.isLoaded = false;
      })
      .addCase(getWhatsappMessageListFromStore.fulfilled, (state, action) => {
        const { data, meta, total } = action.payload;
        state.list = data;
        state.meta = meta;
        state.total = total;
        state.isLoading = false;
        state.isLoaded = true;
      })
      .addCase(getWhatsappMessageListFromStore.rejected, (state) => {
        state.isLoading = false;
        state.isLoaded = true;
      })
  
      // NEW THUNK: Send Welcome Message
      .addCase(sendWelcomeMessageFromStore.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendWelcomeMessageFromStore.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(sendWelcomeMessageFromStore.rejected, (state) => {
        state.isLoading = false;
      });
  }
  
});

export const { resetWhatsappMessageList } = whatsappMessageSlice.actions;

export const selectWhatsappMessageList = (state: RootState) => state.whatsappMessageState;

export default whatsappMessageSlice.reducer;
